export enum InteractionState {
  CHAT,
  CONFIRMATION_FINISH,
  FINISHED,
  DISABLED_CHAT,
}
